import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const Wrapper = styled.div<{ popUpHeight?: number }>`
    display: flex;
    flex-direction: column;
    position: relative;
    height: ${({ popUpHeight }) => (popUpHeight ? `${popUpHeight}px` : "100%")};
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow: hidden;
    height: 100%;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 84px 48px 0 48px;
    height: 100%;
    gap: 40px;
`;

export const LeftContentContainer = styled(ContentContainer)``;

export const RightContentContainer = styled(ContentContainer)`
    width: 45%;
    padding: 84px 48px 18px 48px;
    background-color: ${colorsPalettes.bluegrey[100]};
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Title = styled.h1`
    margin: 0;
    ${setFontVariant("h4", colorsPalettes.carbon[500])};
`;

export const Subtitle = styled.p`
    margin: 0;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
    font-weight: 400;
`;

export const IconButtonContainer = styled.div`
    display: flex;
    justify-content: end;
`;

export const IconButtonStyled = styled(IconButton)`
    position: absolute;
    right: 10px;
    top: 10px;
`;

export const BackIconButtonStyled = styled(IconButton)`
    position: absolute;
    left: 10px;
    top: 10px;
    height: 32px;
    width: 32px;
`;
